var _rect, _rect2, _rect3, _circle, _circle2, _circle3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCodeLoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0537109,
    y: 0.984375,
    width: 33,
    height: 33,
    fill: "#272727"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.53027,
    y: 3.98438,
    width: 28.0391,
    height: 28.0391,
    rx: 1.69934,
    fill: "#434343"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 3.80469,
    y: 11.1484,
    width: 25.4901,
    height: 19.5424,
    fill: "#5B5B5B"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5.18371,
    cy: 7.48547,
    r: 0.954218,
    fill: "#D6B24E"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.64221,
    cy: 7.48547,
    r: 0.954218,
    fill: "#DC594E"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.1007,
    cy: 7.48547,
    r: 0.954218,
    fill: "#38CB89"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 6.78076,
    y: 17.2109,
    width: 4.12886,
    height: 0.849669,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 6.78076,
    y: 17.2109,
    width: 4.12886,
    height: 0.849669,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 6.78076,
    y: 27.3828,
    width: 4.12886,
    height: 0.849669,
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 6.78076,
    y: 19.75,
    width: 3.14643,
    height: 0.849669,
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 6.78076,
    y: 24.8359,
    width: 3.14643,
    height: 0.849669,
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 6.78076,
    y: 22.2969,
    width: 6.42562,
    height: 0.849669,
    fill: "white"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 13.9165,
    y: 22.2969,
    width: 6.42562,
    height: 0.849669,
    fill: "white"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 20.9863,
    y: 22.2969,
    width: 3.48497,
    height: 0.849669,
    fill: "white"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 10.7368,
    y: 19.75,
    width: 6.36588,
    height: 0.849669,
    fill: "white"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 10.7368,
    y: 24.8359,
    width: 6.36588,
    height: 0.849669,
    fill: "white"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 17.9126,
    y: 19.75,
    width: 4.84577,
    height: 0.849669,
    fill: "white"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 17.9126,
    y: 24.8359,
    width: 4.84577,
    height: 0.849669,
    fill: "white"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 23.1831,
    y: 17.2109,
    width: 3.13979,
    height: 0.849669,
    fill: "white"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 23.1831,
    y: 27.3828,
    width: 3.13979,
    height: 0.849669,
    fill: "white"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 11.5869,
    y: 17.2109,
    width: 10.9196,
    height: 0.849669,
    fill: "white"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 11.5869,
    y: 27.3828,
    width: 10.9196,
    height: 0.849669,
    fill: "white"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 9.62891,
    y: 13.6797,
    width: 3.02031,
    height: 0.849669,
    fill: "white"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 6.7832,
    y: 14.1094,
    width: 2.27383,
    height: 0.849669,
    transform: "rotate(-44.6646 6.7832 14.1094)",
    fill: "white"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 7.38721,
    y: 13.5,
    width: 2.27383,
    height: 0.849669,
    transform: "rotate(45 7.38721 13.5)",
    fill: "white"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    width: 2.27383,
    height: 0.849669,
    transform: "matrix(-0.711235 -0.702955 -0.702955 0.711235 15.5474 14.1094)",
    fill: "white"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    width: 2.27383,
    height: 0.849669,
    transform: "matrix(-0.707107 0.707107 0.707107 0.707107 14.9434 13.5)",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodeLoc);
export default __webpack_public_path__ + "static/media/code_loc.801a56a56b5d332bdcf2442613201cd5.svg";
export { ForwardRef as ReactComponent };